import React from 'react'
import styled from "styled-components";

const Heading = ({ size = "16px", align = "center", format = "uppercase", children, mobileText = "", color = "var(--heading-color)" }) => {
    return (
        <Wrap $color={color} $size={size} $format={format} $align={align} >{mobileText !== "" ? mobileText : children}</Wrap>
    )
}

export default Heading


const Wrap = styled.h4`  
    text-transform: ${(props) => (props.$format)};
    font-size: ${(props) => (props.$size)};
    text-align: ${(props) => (props.$align)};
    margin-block: 0;
width: 100%;
     color: ${(props) => (props.$color)};


`

